export const generateSchema = (siteIdentity = {}) => {
  const baseUrl = siteIdentity.url || 'https://blackroll.com';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteIdentity.name || 'BLACKROLL',
    description: siteIdentity.description || undefined,
    url: baseUrl,
    logo: siteIdentity.logo || `${baseUrl}/favicon.ico`,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: siteIdentity.telephone,
      email: siteIdentity.email,
      contactType: 'Customer Service',
    },
    sameAs: siteIdentity.sameAs || [],
  };

  // Add postal address if available
  if (siteIdentity.address?.streetAddress) {
    schema.address = {
      '@type': 'PostalAddress',
      streetAddress: siteIdentity.address.streetAddress,
      addressLocality: siteIdentity.address.addressLocality,
      addressRegion: siteIdentity.address.addressRegion,
      postalCode: siteIdentity.address.postalCode,
      addressCountry: siteIdentity.address.addressCountry,
    };
  }

  return schema;
};
